import * as React from "react";
import "react-phone-input-2/lib/style.css";
import { BrowserRouter as Router } from "react-router-dom";
import AppWithRouterAccess from "./AppWithRouterAccess";
import "bootstrap/dist/css/bootstrap.min.css";

import "./styles.css";

export default function App() {
  return (
    <div className="body">
      <Router>
        <AppWithRouterAccess />
      </Router>
    </div>
  );
}
